<template>
  <div class="main-center-content">
    <top-image-container image-url="static/images/bg/venue-bg.jpg"></top-image-container>
    <div class="main-container margin-gap-v" style="margin-top: 20px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆介绍</el-breadcrumb-item>
        <el-breadcrumb-item>{{venuePageName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-container style="margin-top: 20px;">
        <el-aside width="200px">
          <el-card :body-style="{ padding: '0px' }">
            <div class="left-nav-list">
              <div class="title">场馆介绍</div>
              <div :class="(venuePageType==='AerialView')?'left-nav-item on':'left-nav-item'" v-on:click="toAerialView">
                鸟瞰图
              </div>
              <div :class="(venuePageType==='DistributionMap')?'left-nav-item on':'left-nav-item'"
                   v-on:click="toDistributionMap">分布图
              </div>
            </div>
          </el-card>
        </el-aside>
        <el-main>
          <div style="margin-left: 10px;">
            <el-card>
              <router-view></router-view>
            </el-card>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
  import TopImageContainer from 'src/components/TopImageContainer'
  import {aerialView, distributionMap} from './constant/NavConstant'
  import {mapState} from 'vuex'

  export default {
    data () {
      return {
        venuePageName: ''
      }
    },
    watch: {
      '$store.state.venuePageType': function () {
        let type = this.$store.state.venuePageType
        if (type === aerialView) {
          this.venuePageName = '鸟瞰图'
        } else if (type === distributionMap) {
          this.venuePageName = '分布图'
        }
      }
    },
    computed: mapState({
      venuePageType: state => state.venuePageType
    }),
    components: {
      TopImageContainer
    },
    mounted () {
    },
    methods: {
      toAerialView () {
        this.$router.push({
          name: 'VenueAerialView'
        })
      },
      toDistributionMap () {
        this.$router.push({
          name: 'VenueDistributionMap'
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/venue/index.vue